import { Modal } from "../../common";
import { Button } from "../../App.styles";
import { useTranslation } from "react-i18next";

const PhotoTransformationsModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t('Transformation Instructions')}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p>{t('Transform the player\'s photo submissions after receipt.')}</p>
                <ul>
                    <li>{t(`Apply the prompt provided to edit the photo before it is released to the live stream.`)}</li>
                    <li>{t(`Your prompt will be provided directly to the AI robot artist and its imagination has no limits.`)}</li>
                    <li>{t(`For example: "Change the photo so that all the characters appear as lego characters."`)}</li>
                    <li>{t(`Transformation instructions are required for AI Photo Transformation challenges.`)}</li>
                </ul>
            </div>
            <div className="modal-footer">
                <Button onClick={onDismiss}>{t('Close')}</Button>
            </div>
        </Modal>
    );
};

export default PhotoTransformationsModal;